import React from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { MachineSummary } from 'workflow/interface'

import BaseCell from 'common/components/table/cells/Base'
import TableWidget from 'common/components/widget/tableWidget/TableWidget'

const MachineOpensSummaryWidget = ({
  machineSummary,
}: {
  machineSummary?: MachineSummary
}) => {
  const { showMachineOpens } = useFlags()

  if (!showMachineOpens || !machineSummary) {
    return null
  }

  const columns = [
    { Header: 'Opens', accessor: 'title', disableSortBy: true },
    {
      Header: 'Rate',
      accessor: 'rate',
      disableSortBy: true,
      align: 'right',
      Footer: () => {
        return <BaseCell className="p-3">100%</BaseCell>
      },
    },
    {
      Header: 'Total',
      accessor: 'opens',
      disableSortBy: true,
      align: 'right',
      Footer: () => {
        return <BaseCell className="p-3">{machineSummary.total_opens}</BaseCell>
      },
    },
  ]

  const data = [
    {
      title: 'Machine Opens',
      rate: machineSummary.machine_opens_percent,
      opens: machineSummary.total_machine_opens,
    },
    {
      title: 'Other Opens',
      rate: machineSummary.other_opens_percent,
      opens: machineSummary.total_other_opens,
    },
  ]

  return (
    <div className="mt-6">
      <TableWidget.Widget
        columns={columns}
        className="px-4"
        data={data}
        isHeaderHidden={false}
        data-cy="machine-summary-widget"
      />
    </div>
  )
}

export default MachineOpensSummaryWidget
